import { useTranslate } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';
import { formatTimestampToDate, transformSnakeCaseToPascalCase } from '@/shared/util';

import { usePatientPermissionsAndDetails } from './use-header-permissions.hook';

export function useCopyPatientDetailsData() {
  const translate = useTranslate();
  const {
    patient,
    radiologistScan: { machineID, scanDate },
    studyId,
  } = useStudyGuard();

  const { identifier, patientDisplayDob, patientDisplayName, patientPrenuvoID, skuPackage } =
    usePatientPermissionsAndDetails();

  const CLIPBOARD_VALUES = [
    patientDisplayName,
    patient?.gender
      ? transformSnakeCaseToPascalCase(patient.gender)
      : translate('FCT.REPORTING.HEADER.UNKNOWN.GENDER'),
    translate('FCT.REPORTING.HEADER.CLIPBOARD.PRENUVO_ID', { value: patientPrenuvoID }),
    patientDisplayDob,
    translate('FCT.REPORTING.HEADER.CLIPBOARD.SCAN_DATE', {
      value: formatTimestampToDate(scanDate),
    }),
    translate('FCT.REPORTING.HEADER.CLIPBOARD.SCANNER', {
      value: machineID || translate('FCT.REPORTING.HEADER.UNKNOWN.SCANNER'),
    }),
    translate('FCT.REPORTING.HEADER.CLIPBOARD.IDENTIFIER', { value: identifier }),
    translate('FCT.REPORTING.HEADER.CLIPBOARD.PACKAGE', { value: skuPackage }),
    translate('FCT.REPORTING.HEADER.CLIPBOARD.STUDY_ID', { value: studyId }),
  ];

  return CLIPBOARD_VALUES.filter(Boolean).join('\n');
}
